module.exports = __webpack_public_path__ + "static/media/camera-unable.8b11dab6.svg";